import * as f from "react";
import { composeRef as u } from "../../../depend/rc-util/lib/ref.mjs";
import "../context/FormItemInputContext.mjs";
import { FormContext as i } from "../context/ReoFormCompContext.mjs";
function p() {
  const { itemRef: c } = f.useContext(i), e = f.useRef({});
  function m(o, t) {
    const r = t && typeof t == "object" && t.ref, n = o.join("_");
    return (e.current.name !== n || e.current.originRef !== r) && (e.current.name = n, e.current.originRef = r, e.current.ref = u(c(o), r)), e.current.ref;
  }
  return m;
}
export {
  p as default
};
//# sourceMappingURL=useItemRef.mjs.map
